import React from 'react'
import { Icon } from '@scentregroup/ui'
import SearchProvider from '../search'
import SearchButton from '../search-button'
import { Centre } from '../../../types/contentful-v1'
import { useCountryContext } from '../../context'
import { getAlgoliaApiKeys } from '../../config'

interface Props {
  centre: Centre
  className: string
}

const Search: React.FC<Props> = ({ centre, className }) => {
  const country = useCountryContext()
  return (
    <SearchProvider
      algoliaApiKeys={getAlgoliaApiKeys()}
      centre={centre}
      country={country}
    >
      {showSearch => (
        <SearchButton className={className} showSearch={showSearch}>
          <Icon type="search" />
        </SearchButton>
      )}
    </SearchProvider>
  )
}
export default Search
